import { createGenericSlice } from './GenericSlice';
export const initialState = {
    loading: false,
    error: false,
    response: {},
};
const slice = createGenericSlice('BrazeSubscriptionV2', initialState);
export const actions = slice.actions;
export const sliceName = slice.name;
export const selectBrazeSubscriptionResponse = (state) => state.brazeSubscriptionReducerV2?.response;
const brazeSubscriptionReducer = slice.reducer;
export default brazeSubscriptionReducer;
